

interface ChipProps {
  children: React.ReactNode;
  bgColor: string;
  dataTag?: string;
}

const Chip = ({ bgColor, children, dataTag }: ChipProps) => {
  return (
    <span
      data-tag={dataTag}
      className={`font-normal w-full ${bgColor} w-max inline-flex items-center px-3 py-[5px] rounded-full min-h-[2.25rem]`}
    >
      {children}
    </span>
  );
};

export default Chip;
